// extracted by mini-css-extract-plugin
export default {"animate-shake":"OtpForm_animate-shake__NiZGd","shake":"OtpForm_shake__XTXRA"};